export default class CookieHelper {
  public static getValue(name: string): string | null | undefined {
    return useCookie(name).value;
  }

  public static remove(name: string): void {
    useCookie(name).value = '';
  }

  public static set(name: string, cookieValue: string) {
    const maxAge: number = 60 * 60 * 8;
    useCookie(name, { maxAge }).value = cookieValue;
  }
}
